/**
 * External Dependencies
 */
import viewport from './util/viewport';

import 'jquery';

$(document).ready(() => {
  let width = viewport().width;

  $('#nav-toggle').click(() => {
    $('nav.nav-primary').toggleClass('hidden');
  });

  $('.menu-item-has-children > .nav-link').click((event) => {
    if ( width < 1024 ) {
      event.preventDefault();
    }

    $(event.target).next('ul').toggleClass('hidden');
  });

  $('.menu-item-has-children > .nav-link').mouseover((event) => {
    

    if (width > 1024) {
      $('ul.dropdown-menu').each((count, dropDown) => {
        if(! $(dropDown).hasClass('hidden') ) {
          $(dropDown).addClass('hidden');
        }
      });
      $(event.target).next('ul').toggleClass('hidden');
    }
  });

  $('ul.dropdown-menu').bind('mouseleave', (target) => {
    $(event.currentTarget).toggleClass('hidden');
  });
});
